import React from "react";

const RepartitionHeader = ({ competition }) => {
  return (
    <div className="mx-auto mb-5 w-full max-w-[1680px] text-center">
      <p className="text-xs font-bold uppercase tracking-[0.22em] text-orange-600 dark:text-orange-300">
        Organisateur
      </p>

      <h1 className="mt-2 text-3xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-4xl">
        Répartitions
      </h1>

      <p className="mx-auto mt-2 max-w-3xl text-sm text-slate-600 dark:text-slate-300">
        {competition?.nom_competition}
      </p>
    </div>
  );
};

export default RepartitionHeader;